import {Form, FormField, FormSubmitHandler, NavigateWithoutBlocker} from 'platform/components';
import {Box} from 'platform/foundation';

import {DefaultValues} from 'react-hook-form';

import i18n from '@dms/i18n';
import {SettingsFooter} from '@dms/settings/shared';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {TireDictionaryFormType} from '../../types/TireDictionaryFormType';
import {TireDictionarySchema} from './schemas/TireDictionarySchema';

interface TireDictionaryFormProps extends RequiredTestIdProps {
  onSubmit: FormSubmitHandler<TireDictionaryFormType>;
  defaultValues: DefaultValues<TireDictionaryFormType>;
  onDiscard: (navigateWithoutBlocker: NavigateWithoutBlocker) => void;
}

export function TireDictionaryForm(props: TireDictionaryFormProps) {
  return (
    <Form<TireDictionaryFormType>
      onSubmit={props.onSubmit}
      defaultValues={props.defaultValues}
      experimentalZodSchema={TireDictionarySchema}
      shouldWatchForUnsavedChanges
    >
      {(control, _formApi, navigateWithoutBlocker) => (
        <>
          <Box width={85}>
            <FormField
              control={control}
              name="name"
              type="text"
              label={i18n.t('general.labels.name')}
              isRequired
              data-testid={suffixTestId('name', props)}
            />
          </Box>
          <SettingsFooter
            actions={[
              {
                type: 'button',
                title: i18n.t('general.actions.discardChanges'),
                variant: 'secondary',
                onClick: () => props.onDiscard(navigateWithoutBlocker),
              },
              {
                control,
                type: 'form-button',
                buttonType: 'submit',
                title: i18n.t('general.actions.saveChanges'),
              },
            ]}
            data-testid={suffixTestId('footer', props)}
          />
        </>
      )}
    </Form>
  );
}
